import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { InvoicePosition } from '../rechnung';

@Component({
    selector: 'kiene-delete-rechnung-position-dialog',
    templateUrl: './delete-rechnung-position-dialog.component.html',
    styleUrls: ['./delete-rechnung-position-dialog.component.css'],
})
export class DeleteRechnungPositionDialogComponent implements OnInit {
    position: InvoicePosition;
    gutschriftCtrl = new UntypedFormControl(false);

    constructor(
        public dialogRef: MatDialogRef<DeleteRechnungPositionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneTableService,
        private messageService: MessageService,
    ) {
        this.position = this.data.position;
    }

    ngOnInit(): void {}

    close() {
        this.dialogRef.close();
    }

    delete() {
        this.position.gutschrift = this.gutschriftCtrl.value ? 1 : 0;
        this.api.deleteGeneric(this.apiBaseUrl + 'rechnung/delete_artikel.php', this.position).subscribe(
            () => {
                this.messageService.infoMessage('Die Position wurde erfolgreich gelöscht!');
                this.close();
            },
            error => {
                this.messageService.errorMessage('Die Position konnte nicht gelöscht werden!', error);
            },
        );
    }
}
